var _style, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 184 55.6",
    style: {
      enableBackground: "new 0 0 184 55.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000018219477167386755130000014377641844149761167_);fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 184,
    height: 55.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129165129506434813910000010554794349539037852_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    d: "M23.7,28.9v-8.4 c-3.7,1.3-6.1,2.4-7,3.3c-0.9,0.9-1.4,2-1.4,3.5c0,1.3,0.4,2.3,1.1,3.1c0.7,0.8,1.6,1.2,2.8,1.2c0.8,0,1.6-0.2,2.4-0.7 C22.4,30.5,23.1,29.8,23.7,28.9 M23.8,30.5c-0.9,1-1.9,1.8-3,2.3c-1.2,0.5-2.4,0.8-3.7,0.8c-1.8,0-3.2-0.5-4.3-1.5 c-1.1-1-1.7-2.4-1.7-4c0-2.9,3.7-5.6,11-8c0.7-0.2,1.3-0.4,1.7-0.5v-0.8c0-2-0.4-3.6-1.3-4.7c-0.9-1.1-2.1-1.6-3.7-1.6 c-1.4,0-2.6,0.4-3.7,1.2c-1,0.8-1.8,1.9-2.3,3.4h-1c0.5-2.1,1.5-3.7,2.9-4.9c1.4-1.2,3.2-1.8,5.2-1.8c2.8,0,4.9,0.8,6.2,2.3 c1.3,1.5,2,3.9,2,7.2v8.4c0,1.3,0.1,2.1,0.3,2.5c0.2,0.4,0.5,0.6,1,0.6c0.4,0,0.7-0.2,1-0.5c0.3-0.3,0.4-0.8,0.6-1.5h0.8 c-0.1,1.3-0.6,2.4-1.4,3.2c-0.8,0.8-1.7,1.2-2.9,1.2c-0.9,0-1.7-0.3-2.3-0.8C24.5,32.3,24,31.5,23.8,30.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    d: "M41.9,26.3 c1.7,0,3-0.7,4-2c1-1.3,1.5-3.1,1.5-5.4c0-2.3-0.5-4.1-1.5-5.4c-1-1.3-2.3-2-4-2c-1.7,0-3,0.7-4,2c-1,1.3-1.5,3.1-1.5,5.4 c0,2.3,0.5,4.1,1.5,5.4C38.9,25.6,40.2,26.3,41.9,26.3 M39,38c-2.1,0.5-3.7,1.2-4.8,2.2c-1.2,0.9-1.7,1.9-1.7,3c0,1.5,1,2.8,3,3.9 c2,1.1,4.4,1.6,7.4,1.6c2.8,0,5-0.4,6.7-1.3c1.7-0.9,2.5-2,2.5-3.5c0-1.5-1-2.7-2.9-3.6C47.1,39.4,43.8,38.6,39,38 M37.1,37.6 c-1.5-0.4-2.7-0.9-3.6-1.7c-0.9-0.7-1.3-1.6-1.3-2.5c0-1.1,0.6-2.2,1.7-3.2c1.1-1,2.9-2,5.4-3c-2.2-0.6-3.9-1.6-5.1-3 C33,22.7,32.3,21,32.3,19c0-2.6,0.9-4.7,2.8-6.2c1.9-1.6,4.4-2.4,7.5-2.4c0.2,0,1.1,0.1,2.9,0.2c1.8,0.1,3.4,0.2,5,0.2h4.1v2.1 h-5.5c0.8,1,1.4,1.9,1.8,2.9c0.4,1,0.6,2,0.6,3.1c0,2.3-0.7,4.1-2.1,5.4c-1.4,1.4-3.5,2.4-6.4,3c-2.3,0.5-4,1.1-5.3,1.9 c-1.3,0.8-1.9,1.6-1.9,2.5c0,1.3,2,2.3,5.9,3.1c1.1,0.2,1.9,0.4,2.5,0.5c4.2,0.9,7.1,1.9,8.4,2.8c1.4,0.9,2.1,2.3,2.1,3.9 c0,2.3-1.3,4.3-4,6c-2.7,1.7-5.9,2.6-9.7,2.6c-3.3,0-5.9-0.6-8-1.8c-2-1.2-3-2.7-3-4.5c0-1.5,0.6-2.7,1.8-3.9 C32.8,39.5,34.7,38.5,37.1,37.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    d: "M56.9,23.9h6.9 l-3.6-8.8L56.9,23.9z M55.1,28.7c0,0.1-0.1,0.2-0.1,0.3c-0.3,0.9-0.5,1.6-0.5,2c0,0.3,0.1,0.6,0.4,0.8c0.3,0.2,0.6,0.4,1.1,0.5V33 c-0.5,0-1-0.1-1.5-0.1c-0.5,0-1,0-1.6,0c-0.5,0-1,0-1.5,0c-0.5,0-1,0-1.4,0.1l0-0.6c0.8-0.1,1.4-0.4,2-1c0.6-0.6,1.1-1.5,1.6-2.7 l6.9-18.1h3l7.2,18.1c0.5,1.2,1,2.1,1.6,2.7c0.6,0.6,1.3,0.9,2,1l0,0.6c-0.8,0-1.6-0.1-2.4-0.1c-0.8,0-1.6,0-2.4,0s-1.6,0-2.4,0 c-0.8,0-1.6,0-2.4,0.1v-0.6c0.5-0.1,0.9-0.3,1.1-0.5c0.3-0.2,0.4-0.5,0.4-0.8c0-0.3,0-0.6-0.1-0.9c-0.1-0.3-0.2-0.8-0.5-1.4l-1.2-3 h-8L55.1,28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    d: "M72.9,33v-0.6 c1.1,0,2-0.5,2.7-1.2c0.7-0.8,1.1-2,1.4-3.7L79.5,13c-0.3-0.5-0.8-0.8-1.3-1.1c-0.6-0.3-1.2-0.5-2-0.6l0-0.6c0.6,0,1.3,0.1,2,0.1 c0.7,0,1.3,0,2,0c0.7,0,1.3,0,2,0c0.7,0,1.3,0,2-0.1c1.1,2.4,2.1,4.9,3.1,7.4c1,2.5,2,5.1,2.9,7.8l6.4-15.2c0.6,0,1.3,0.1,1.9,0.1 c0.6,0,1.3,0,1.9,0c0.6,0,1.2,0,1.8,0c0.6,0,1.2,0,1.8-0.1v0.6c-0.8,0-1.4,0.3-1.8,0.8c-0.5,0.5-0.7,1.2-0.7,2.1c0,0.1,0,0.3,0,0.5 c0,0.2,0.1,0.4,0.1,0.6l1.8,12.8c0.2,1.3,0.5,2.3,1.1,2.9c0.6,0.7,1.3,1.1,2.4,1.3V33c-0.9,0-1.7-0.1-2.6-0.1c-0.9,0-1.8,0-2.7,0 c-0.9,0-1.8,0-2.8,0c-0.9,0-1.8,0-2.8,0.1v-0.6c0.8-0.1,1.4-0.4,1.9-1c0.5-0.6,0.7-1.3,0.7-2.3c0-0.3,0-0.5,0-0.8 c0-0.3,0-0.5-0.1-0.7l-1.9-13L88.9,33h-0.8c-1.6-4.2-2.9-7.7-4.1-10.7c-1.1-2.9-2.2-5.6-3.2-7.9l-2.4,13.5c0,0.2-0.1,0.4-0.1,0.6 c0,0.2,0,0.4,0,0.7c0,0.9,0.3,1.7,0.8,2.2c0.5,0.6,1.2,0.9,2.1,0.9V33c-0.7,0-1.3-0.1-2-0.1c-0.7,0-1.4,0-2.1,0c-0.7,0-1.4,0-2.1,0 C74.3,32.9,73.6,32.9,72.9,33"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    d: "M110.9,14.4l-0.3,1.4 h-0.8l1.2-5.5h1l1.1,5.5h-0.8l-0.3-1.4H110.9z M111.9,13.8l-0.2-1.3c-0.1-0.4-0.1-0.9-0.2-1.2h0c-0.1,0.4-0.1,0.9-0.2,1.2l-0.2,1.3 H111.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    d: "M116.9,15.7 c-0.2,0.1-0.7,0.2-1.1,0.2c-0.6,0-1-0.2-1.4-0.5c-0.4-0.4-0.7-1.2-0.7-2.2c0-2.1,1.1-2.8,2.2-2.8c0.4,0,0.7,0.1,0.8,0.2l-0.2,0.7 c-0.1-0.1-0.3-0.1-0.6-0.1c-0.7,0-1.4,0.5-1.4,2.1c0,1.5,0.6,2,1.1,2c0.1,0,0.2,0,0.3,0v-1.5h-0.6v-0.7h1.4V15.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    points: "120.2,13.4  118.9,13.4 118.9,15.1 120.3,15.1 120.3,15.9 118,15.9 118,10.4 120.3,10.4 120.3,11.2 118.9,11.2 118.9,12.7 120.2,12.7  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    d: "M121.4,15.9v-5.5h0.8 l0.9,2.3c0.2,0.5,0.5,1.2,0.6,1.7h0c0-0.7-0.1-1.5-0.1-2.5v-1.5h0.8v5.5h-0.8l-0.9-2.3c-0.2-0.5-0.4-1.2-0.6-1.7h0 c0,0.6,0.1,1.4,0.1,2.5v1.5H121.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    d: "M128.2,15.8 c-0.2,0.1-0.4,0.1-0.8,0.1c-1.2,0-2-1-2-2.7c0-2.1,1.1-2.9,2.1-2.9c0.4,0,0.6,0.1,0.7,0.1l-0.2,0.7c-0.1-0.1-0.3-0.1-0.5-0.1 c-0.6,0-1.2,0.5-1.2,2c0,1.5,0.6,2,1.2,2c0.2,0,0.4,0,0.5-0.1L128.2,15.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    points: "131.3,13.4  130,13.4 130,15.1 131.5,15.1 131.5,15.9 129.1,15.9 129.1,10.4 131.4,10.4 131.4,11.2 130,11.2 130,12.7 131.3,12.7  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    d: "M134.1,10.5 c0.3-0.1,0.6-0.1,1-0.1c0.6,0,1.1,0.2,1.4,0.5c0.4,0.4,0.7,1.1,0.7,2.2c0,1.2-0.3,1.9-0.7,2.3c-0.4,0.4-0.9,0.6-1.6,0.6 c-0.3,0-0.6,0-0.8-0.1V10.5z M135,15.2c0.1,0,0.2,0,0.2,0c0.6,0,1.1-0.5,1.1-2.2c0-1.2-0.4-2-1.1-2c-0.1,0-0.2,0-0.3,0V15.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    points: "138.8,10.3  138.7,12.3 138.2,12.3 138.1,10.3  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    d: "M140.8,10.4V14 c0,0.9,0.3,1.2,0.6,1.2c0.4,0,0.6-0.3,0.6-1.2v-3.6h0.9v3.5c0,1.4-0.6,2.1-1.5,2.1c-1,0-1.5-0.7-1.5-2v-3.5H140.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    d: "M144.2,10.5 c0.3-0.1,0.7-0.1,1-0.1c0.6,0,1,0.1,1.4,0.4c0.3,0.3,0.4,0.7,0.4,1.1c0,0.6-0.3,1.1-0.9,1.4v0c0.4,0.1,0.6,0.5,0.7,1.2 c0.1,0.7,0.3,1.2,0.3,1.4h-0.9c-0.1-0.2-0.2-0.7-0.3-1.3c-0.1-0.7-0.3-0.9-0.7-0.9H145v2.3h-0.9V10.5z M145,12.9h0.2 c0.5,0,0.8-0.4,0.8-1c0-0.5-0.2-0.9-0.8-0.9c-0.1,0-0.2,0-0.3,0V12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    d: "M148.1,10.5 c0.3-0.1,0.7-0.1,1.1-0.1c0.5,0,1,0.1,1.3,0.4c0.3,0.2,0.4,0.6,0.4,1c0,0.5-0.3,1-0.8,1.2v0c0.6,0.2,1,0.7,1,1.3 c0,0.4-0.1,0.8-0.4,1.1c-0.3,0.3-0.9,0.5-1.6,0.5c-0.4,0-0.7,0-0.9-0.1V10.5z M149,12.7h0.3c0.4,0,0.8-0.4,0.8-0.9 c0-0.5-0.2-0.8-0.7-0.8c-0.1,0-0.2,0-0.3,0V12.7z M149,15.2c0.1,0,0.2,0,0.3,0c0.5,0,0.9-0.3,0.9-0.9c0-0.6-0.4-1-0.9-1H149V15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    d: "M152.9,14.4l-0.3,1.4 h-0.8l1.2-5.5h1l1.1,5.5h-0.8l-0.3-1.4H152.9z M153.9,13.8l-0.2-1.3c-0.1-0.4-0.1-0.9-0.2-1.2h0c-0.1,0.4-0.1,0.9-0.2,1.2l-0.2,1.3 H153.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    d: "M156.1,15.9v-5.5h0.8 l0.9,2.3c0.2,0.5,0.5,1.2,0.6,1.7h0c0-0.7-0.1-1.5-0.1-2.5v-1.5h0.8v5.5h-0.8l-0.9-2.3c-0.2-0.5-0.4-1.2-0.6-1.7h0 c0,0.6,0.1,1.4,0.1,2.5v1.5H156.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.4,
    y: 10.4,
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    width: 0.9,
    height: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    d: "M162.4,14.9 c0.2,0.1,0.6,0.2,0.8,0.2c0.5,0,0.8-0.3,0.8-0.8c0-0.4-0.3-0.7-0.7-1c-0.6-0.4-1-0.9-1-1.5c0-0.9,0.6-1.5,1.6-1.5 c0.3,0,0.7,0.1,0.8,0.2l-0.2,0.7c-0.1-0.1-0.4-0.2-0.7-0.2c-0.5,0-0.7,0.3-0.7,0.7c0,0.4,0.2,0.6,0.8,1c0.7,0.5,1,1,1,1.6 c0,1-0.7,1.6-1.7,1.6c-0.4,0-0.8-0.1-1-0.2L162.4,14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    d: "M169.2,13.8 c0-0.6-0.1-1.4-0.1-2h0c-0.1,0.6-0.3,1.3-0.4,1.8l-0.6,2.2h-0.6l-0.5-2.2c-0.1-0.6-0.3-1.2-0.4-1.8h0c0,0.6,0,1.3-0.1,2l-0.1,2.1 h-0.8l0.4-5.5h0.9l0.5,2.2c0.2,0.7,0.3,1.3,0.4,1.9h0c0.1-0.6,0.2-1.2,0.4-1.9l0.5-2.2h0.9l0.3,5.5h-0.8L169.2,13.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    points: "173.4,13.4  172.1,13.4 172.1,15.1 173.6,15.1 173.6,15.9 171.3,15.9 171.3,10.4 173.5,10.4 173.5,11.2 172.1,11.2 172.1,12.7 173.4,12.7  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    d: "M110.2,19.1 c0.3-0.1,0.6-0.1,1-0.1c0.6,0,1.1,0.2,1.4,0.5c0.4,0.4,0.7,1.1,0.7,2.2c0,1.2-0.3,1.9-0.7,2.3c-0.4,0.4-0.9,0.6-1.6,0.6 c-0.3,0-0.6,0-0.8-0.1V19.1z M111,23.8c0.1,0,0.2,0,0.2,0c0.6,0,1.1-0.5,1.1-2.2c0-1.2-0.4-2-1.1-2c-0.1,0-0.2,0-0.3,0V23.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    points: "116.5,22  115.2,22 115.2,23.7 116.7,23.7 116.7,24.5 114.3,24.5 114.3,19 116.6,19 116.6,19.7 115.2,19.7 115.2,21.2 116.5,21.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    points: "119.3,19  120.2,19 120.2,23.7 121.6,23.7 121.6,24.5 119.3,24.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    points: "122.5,18.9  122.4,20.9 121.9,20.9 121.8,18.9  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    d: "M124,23l-0.3,1.4h-0.8 l1.2-5.5h1l1.1,5.5h-0.8l-0.3-1.4H124z M125,22.4l-0.2-1.3c-0.1-0.4-0.1-0.9-0.2-1.2h0c-0.1,0.4-0.1,0.9-0.2,1.2l-0.2,1.3H125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    d: "M129.9,24.3 c-0.2,0.1-0.7,0.2-1.1,0.2c-0.6,0-1-0.2-1.4-0.5c-0.4-0.4-0.7-1.2-0.7-2.2c0-2.1,1.1-2.8,2.2-2.8c0.4,0,0.7,0.1,0.8,0.2l-0.2,0.7 c-0.1-0.1-0.4-0.1-0.6-0.1c-0.7,0-1.4,0.5-1.4,2.1c0,1.5,0.6,2,1.1,2c0.1,0,0.2,0,0.3,0v-1.5h-0.6v-0.7h1.4V24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    d: "M133.9,24.3 c-0.2,0.1-0.7,0.2-1.1,0.2c-0.6,0-1-0.2-1.4-0.5c-0.4-0.4-0.7-1.2-0.7-2.2c0-2.1,1.1-2.8,2.2-2.8c0.4,0,0.7,0.1,0.8,0.2l-0.2,0.7 c-0.1-0.1-0.3-0.1-0.6-0.1c-0.7,0-1.4,0.5-1.4,2.1c0,1.5,0.6,2,1.1,2c0.1,0,0.2,0,0.3,0v-1.5h-0.6v-0.7h1.4V24.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    points: "135.1,19  135.9,19 135.9,23.7 137.4,23.7 137.4,24.5 135.1,24.5  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    d: "M141.1,21.6 c0,2.1-0.7,2.9-1.7,2.9c-1.1,0-1.6-1.2-1.6-2.8c0-1.6,0.6-2.8,1.7-2.8C140.7,18.9,141.1,20.2,141.1,21.6 M138.7,21.7 c0,1.2,0.2,2,0.8,2c0.6,0,0.7-1,0.7-2.1c0-1-0.2-2-0.7-2C138.9,19.7,138.7,20.6,138.7,21.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    d: "M145.5,22.3 c0-0.6-0.1-1.4-0.1-2h0c-0.1,0.6-0.2,1.3-0.4,1.8l-0.6,2.2h-0.6l-0.5-2.2c-0.1-0.5-0.3-1.2-0.4-1.8h0c0,0.6,0,1.3-0.1,2l-0.1,2.1 H142l0.4-5.5h0.9l0.5,2.2c0.2,0.7,0.3,1.3,0.4,1.9h0c0.1-0.6,0.2-1.2,0.4-1.9l0.5-2.2h0.9l0.3,5.5h-0.8L145.5,22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    d: "M149.7,22h-1.3v1.7h1.5 v0.8h-2.3V19h2.2v0.8h-1.4v1.5h1.3V22z M149.9,17.8l-1,0.9h-0.6l0.7-0.9H149.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    d: "M150.9,19.1 c0.3-0.1,0.7-0.1,1-0.1c0.6,0,1,0.1,1.4,0.4c0.3,0.3,0.4,0.7,0.4,1.1c0,0.6-0.3,1.1-0.9,1.4v0c0.4,0.1,0.6,0.5,0.7,1.1 c0.1,0.7,0.3,1.2,0.3,1.4H153c-0.1-0.2-0.2-0.7-0.3-1.3c-0.1-0.7-0.3-0.9-0.7-0.9h-0.2v2.3h-0.9V19.1z M151.7,21.5h0.2 c0.5,0,0.8-0.4,0.8-1c0-0.5-0.2-0.9-0.8-0.9c-0.1,0-0.2,0-0.3,0V21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    d: "M155.6,23l-0.3,1.4 h-0.8l1.2-5.5h1l1.1,5.5H157l-0.3-1.4H155.6z M156.6,22.4l-0.2-1.3c-0.1-0.4-0.1-0.9-0.2-1.2h0c-0.1,0.4-0.1,0.9-0.2,1.2l-0.2,1.3 H156.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    points: "159,19.8  158,19.8 158,19 160.8,19 160.8,19.8 159.8,19.8 159.8,24.5 159,24.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.7,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    width: 0.9,
    height: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    d: "M166.9,21.6 c0,2.1-0.7,2.9-1.7,2.9c-1.1,0-1.6-1.2-1.6-2.8c0-1.6,0.6-2.8,1.7-2.8C166.5,18.9,166.9,20.2,166.9,21.6 M164.5,21.7 c0,1.2,0.2,2,0.8,2c0.6,0,0.7-1,0.7-2.1c0-1-0.2-2-0.7-2C164.8,19.7,164.5,20.6,164.5,21.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    d: "M168,24.5V19h0.8 l0.9,2.3c0.2,0.5,0.5,1.2,0.6,1.7h0c0-0.7-0.1-1.5-0.1-2.5V19h0.8v5.5h-0.8l-0.9-2.3c-0.2-0.5-0.4-1.2-0.6-1.7h0 c0,0.6,0.1,1.4,0.1,2.5v1.5H168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    d: "M113.5,30.9 c0-0.6-0.1-1.4-0.1-2h0c-0.1,0.6-0.3,1.3-0.4,1.8l-0.6,2.2h-0.6l-0.5-2.2c-0.1-0.6-0.3-1.2-0.4-1.8h0c0,0.6,0,1.3-0.1,2l-0.1,2.1 H110l0.4-5.5h0.9l0.5,2.2c0.2,0.7,0.3,1.3,0.4,1.9h0c0.1-0.6,0.2-1.2,0.4-1.9l0.5-2.2h0.9l0.3,5.5h-0.8L113.5,30.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    d: "M116.3,31.6L116,33 h-0.8l1.2-5.5h1l1.1,5.5h-0.8l-0.3-1.4H116.3z M117.3,30.9l-0.2-1.3c-0.1-0.4-0.1-0.9-0.2-1.2h0c-0.1,0.4-0.1,0.9-0.2,1.2l-0.2,1.3 H117.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    d: "M119.4,27.6 c0.3-0.1,0.7-0.1,1-0.1c0.6,0,1,0.1,1.4,0.4c0.3,0.3,0.4,0.7,0.4,1.1c0,0.6-0.3,1.1-0.9,1.4v0c0.4,0.1,0.6,0.5,0.7,1.2 c0.1,0.7,0.3,1.2,0.3,1.4h-0.9c-0.1-0.2-0.2-0.7-0.3-1.3c-0.1-0.7-0.3-0.9-0.7-0.9h-0.2V33h-0.9V27.6z M120.3,30.1h0.2 c0.5,0,0.8-0.4,0.8-1c0-0.5-0.2-0.9-0.8-0.9c-0.1,0-0.2,0-0.3,0V30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    d: "M123.2,32.1 c0.2,0.1,0.6,0.2,0.8,0.2c0.5,0,0.8-0.3,0.8-0.8c0-0.4-0.3-0.7-0.7-1c-0.6-0.4-1-0.9-1-1.5c0-0.9,0.6-1.5,1.6-1.5 c0.3,0,0.7,0.1,0.8,0.2l-0.2,0.7c-0.1-0.1-0.4-0.2-0.7-0.2c-0.5,0-0.7,0.3-0.7,0.7c0,0.4,0.2,0.6,0.8,1c0.7,0.5,1,1,1,1.6 c0,1-0.7,1.6-1.7,1.6c-0.4,0-0.8-0.1-1-0.2L123.2,32.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    points: "128.9,30.5  127.6,30.5 127.6,32.3 129.1,32.3 129.1,33 126.8,33 126.8,27.6 129,27.6 129,28.3 127.6,28.3 127.6,29.8 128.9,29.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.1,
    y: 27.6,
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    width: 0.9,
    height: 5.5
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    points: "132.3,27.6  133.2,27.6 133.2,32.3 134.6,32.3 134.6,33 132.3,33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    points: "135.6,27.6  136.4,27.6 136.4,32.3 137.9,32.3 137.9,33 135.6,33  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    d: "M139.7,31.6l-0.3,1.4 h-0.8l1.2-5.5h1l1.1,5.5H141l-0.3-1.4H139.7z M140.7,30.9l-0.2-1.3c-0.1-0.4-0.1-0.9-0.2-1.2h0c-0.1,0.4-0.1,0.9-0.2,1.2l-0.2,1.3 H140.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.8,
    y: 27.6,
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    width: 0.9,
    height: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    d: "M144.9,32.1 c0.2,0.1,0.6,0.2,0.8,0.2c0.5,0,0.8-0.3,0.8-0.8c0-0.4-0.3-0.7-0.7-1c-0.6-0.4-1-0.9-1-1.5c0-0.9,0.6-1.5,1.6-1.5 c0.3,0,0.7,0.1,0.8,0.2l-0.2,0.7c-0.1-0.1-0.4-0.2-0.7-0.2c-0.5,0-0.7,0.3-0.7,0.7c0,0.4,0.2,0.6,0.8,1c0.7,0.5,1,1,1,1.6 c0,1-0.7,1.6-1.7,1.6c-0.4,0-0.8-0.1-1-0.2L144.9,32.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000129165129506434813910000010554794349539037852_)",
      fill: "#FFFFFF"
    },
    points: "150.6,30.5  149.3,30.5 149.3,32.3 150.7,32.3 150.7,33 148.4,33 148.4,27.6 150.6,27.6 150.6,28.3 149.3,28.3 149.3,29.8 150.6,29.8  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgam);
export default __webpack_public_path__ + "static/media/agam.833b3909ca2ae937cfdf7a66a8848bb0.svg";
export { ForwardRef as ReactComponent };